import { WarningSchema } from "@/schemas/warning-data-schema";
import { formatDateTime } from "../../helpers/format-details-date";
import { getColorStatusByColor } from "../../helpers/get-color-by-value";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { useTranslation } from "react-i18next";
import { formatDetailIconWithLayer } from "../../helpers/format-detail-icon";

import "./style.scss";

type ContentEventDetailsCardProps = {
	data: WarningSchema;
};

export const ContentEventDetailsCard = ({
	data,
}: ContentEventDetailsCardProps) => {
	const { t } = useTranslation();
	const lang = getCurrentLanguage();
	const formatLang = lang === "ar" ? "ar-AR" : "en-US";

	const { onset, expires, effective, layer, area_desc, value } =
		data.properties;

	const iconJsx = formatDetailIconWithLayer(layer);

	return (
		<div className="content-event-details-card">
			<div className="content-event-icon">
				{iconJsx ? <img src={iconJsx} alt="weather" /> : null}
			</div>
			<span
				className="weather-bar-status"
				style={{ backgroundColor: getColorStatusByColor(value) }}
			></span>
			<p className="title">{`${data.properties[`headline_${formatLang}`]} ${t(
				"forLocation",
			)} ${area_desc}`}</p>

			<ul>
				<li>
					{t("issueDate")}: {formatDateTime(effective)}
				</li>
				<li>
					{t("startDate")} : {formatDateTime(onset)}
				</li>
				<li>
					{t("endDate")}: {formatDateTime(expires)}
				</li>
			</ul>

			<div className="desc-content">
				<p className="title-desc">{t("impact")}</p>
				<p className="desc">{data.properties[`description_${formatLang}`]}</p>
			</div>

			<div className="desc-content">
				<p className="title-desc">{t("instruction")}</p>
				<p className="desc">{data.properties[`instruction_${formatLang}`]}</p>
			</div>
		</div>
	);
};

export default ContentEventDetailsCard;
